export const getStudioHomeData = state => state.studioHome.studioHomeData;
export const getLoadingStatuses = (state) => state.studioHome.loadingStatuses;
export const getSavingStatuses = (state) => state.studioHome.savingStatuses;
export const getStudioHomeCoursesParams = (state) => state.studioHome.studioHomeCoursesRequestParams;
export const getStudioHomeLibrariesParams = (state) => state.studioHome.studioHomeLibrariesRequestParams;
export const getLibraryFilterCourses = (state) => state.studioHome.studioHomeData.libraryFilterCourses || [];
export const getCourseFilterLanguages = (state) => state.studioHome.studioHomeData.courseFilterLanguages || [];
